/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// actions
import { updatePageDetails, changePage, displayMessage } from '@insticator/insticator-ui'; // iui-state
// utils
import { setLocalStorage, hasLocalStorage } from '@insticator/insticator-ui'; // iui-utils
import { receiveDashboardMessage } from 'utils/api/messages';
// material
import { Link } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

export const displayDashboardMessage = text => displayMessage({
    enabled: true, // defaults to true if NOT set or set to anything OTHER THAN false
    name: 'reportingdelay',
    type: 'incontent',
    variant: 'warning',
    time: null,
    align: null,
    icon: 'exclamation-triangle',
    title: null,
    message: text,
    close: true,
    handleClose: () => setLocalStorage('reportingdelay'), // localstorage item = name property of this message
    pages: ['dashboard/home', 'dashboard/analytics/detail', 'dashboard/reports'],
    pagesExcluded: ['dashboard/account/paymentinfo', 'dashboard/embeds/management', 'dashboard/reports/detail']
});


// ---- HELPER ---- //
export const hasMessage = (arrContainer, propName, propValue) => arrContainer.some(prop => prop[propName] === propValue);



//-------------------- Status Code Error Actions --------------------//
const moveToPage = (location) => dispatch => {
    dispatch(updatePageDetails(location));
    dispatch(changePage(location));
};

export const failedApiCallReroute = (statusCode) => {
    switch (statusCode) {
        case 404:
            return moveToPage('error/404');
        case 403:
            return moveToPage('error/403');
        default:
            return moveToPage('error/500');
    }
};


//
export const handleDashboardMessage = () => dispatch => {
    return receiveDashboardMessage()
        .then(response => {
            if(response.data.showMessage) return dispatch(displayDashboardMessage(response.data.message))
        })
};

